@use "../../styles/layout.module.scss" as l;
@use "../../styles/breakpoint.module.scss" as *;

.root {
    grid-column: content;

    --carousel-dots-gap: var(--spacer-8);
}

.scroller:has(~ [aria-label="Choose slide to display"]) {
    margin-bottom: var(--spacer-40);
}

// Target the slides wrapper (direct child of scroll container)
.scroller > div {
    display: grid;
    grid-template-rows: repeat(2, max-content);
    grid-auto-flow: column;
    gap: var(--spacer-gutter);
    justify-content: safe center;
    // Desktop: 4 columns per "page" (8 cards total)
    --column-count: 4;

    grid-auto-columns: calc(
        (100% - var(--spacer-gutter) * (var(--column-count) - 1)) /
            var(--column-count)
    );

    // Tablet: 3 columns per "page" (6 cards total)
    @media ($below-tablet) {
        --column-count: 3;
    }

    // Mobile: 2 columns per "page" (4 cards total)
    @media ($below-mobile) {
        --column-count: 2;
    }
}

// Override Carousel's slide wrapper to work with grid
.scroller [aria-roledescription="slide"] {
    display: block;
    scroll-snap-align: none;

    // Apply scroll snap to first card of each "page"
    // Mobile: every 4th card (cards 1, 5, 9, ...)
    @media ($below-mobile) {
        &:nth-child(4n + 1) {
            scroll-snap-align: start;
        }
    }

    // Tablet: every 6th card (cards 1, 7, 13, ...)
    @media ($above-mobile) and ($below-tablet) {
        &:nth-child(6n + 1) {
            scroll-snap-align: start;
        }
    }

    // Desktop: every 8th card (cards 1, 9, 17, ...)
    @media ($above-tablet) {
        &:nth-child(8n + 1) {
            scroll-snap-align: start;
        }
    }
}

.card {
    composes: fontHB40 from "../../styles/typography.module.scss";
    composes: base from "../Clickables/index.module.scss";
    color: var(--white);
    position: relative;
    aspect-ratio: 3 / 4;
    display: block;
    width: 100%;
    height: 100%;
}

.foreground {
    position: absolute;
    inset: 0;
    padding: var(--spacer-24);
    display: flex;
    align-items: end;
    justify-content: space-between;
    gap: var(--spacer-12);
    background: var(--transparency-gradient);

    // Style the title text (first span child)
    > span:first-child {
        min-width: 0; // Allow flex item to shrink below content size
    }
}

.icon {
    flex-shrink: 0;

    --size: 40px;

    width: var(--size);
    height: var(--size);
    background-color: currentColor;
    border-radius: var(--border-radius-full);
    display: flex;
    align-items: center;
    justify-content: center;

    @media ($below-mobile) {
        --size: 32px;
    }

    svg {
        width: 16px;
        height: 16px;
        margin-left: 0;
        color: var(--color-contrast, var(--red));
    }

    .card[data-hovered] & {
        background-color: var(--color-contrast, var(--red));

        & svg {
            color: inherit;
        }
    }
}
